import React, { useEffect, useState } from 'react'

import LoadingIndicator from '../components/LoadingIndicator'

export default (Component, LoadingComponent = LoadingIndicator) => {
  return props => {
    const [EditorState, setEditorState] = useState(null)
    const [libState, setLibState] = useState(null)

    useEffect(() => {
      async function loadTiny() {
        const { Editor, tinymce } = await import(
          /* webpackChunkName: "tinymce-react" */ '@h2/common/components/tinyMceBundle.js'
        )

        setLibState(tinymce)
        //Need to wrap because otherwise setState will invoke the component function
        setEditorState(() => Editor)
      }
      loadTiny()
    }, [])

    if (EditorState && libState) {
      const allProps = { ...props, tinymce: libState, TinyMCE: EditorState }

      return <Component {...allProps} />
    }

    return (
      <LoadingComponent newSiteLook={dynamicValues.newSiteLook} unContained={false} />
    )
  }
}
